import { baseTranslations } from "@c15t/translations/all";
import type { I18nConfig } from "c15t";
import * as m from "~/paraglide/messages.js";
import { getLocale } from "~/paraglide/runtime.js";

export function buildC15tI18n(): I18nConfig {
  const locale = getLocale();
  return {
    detectBrowserLanguage: false,
    locale,
    messages: {
      en: {
        ...baseTranslations.en,
        cookieBanner: {
          ...baseTranslations.en.cookieBanner,
          description: m.cookie_description({}, { locale: "en" }),
          title: m.cookie_title({}, { locale: "en" }),
        },
      },
      lv: {
        ...baseTranslations.lv,
        consentManagerDialog: {
          ...baseTranslations.lv.consentManagerDialog,
          description: m.cookie_dialog_description({}, { locale: "lv" }),
        },
        consentTypes: {
          ...baseTranslations.lv.consentTypes,
          marketing: {
            ...baseTranslations.lv.consentTypes.marketing,
            description: m.cookie_marketing_description({}, { locale: "lv" }),
          },
          measurement: {
            ...baseTranslations.lv.consentTypes.measurement,
            description: m.cookie_measurement_description({}, { locale: "lv" }),
          },
        },
        cookieBanner: {
          ...baseTranslations.lv.cookieBanner,
          description: m.cookie_description({}, { locale: "lv" }),
          title: m.cookie_title({}, { locale: "lv" }),
        },
        frame: {
          ...baseTranslations.lv.frame,
          actionButton: m.cookie_frame_action(
            { category: "{category}" },
            { locale: "lv" }
          ),
          error: m.cookie_frame_error({}, { locale: "lv" }),
          loading: m.cookie_frame_loading({}, { locale: "lv" }),
          policyBlocked: m.cookie_frame_policy_blocked({}, { locale: "lv" }),
          title: m.cookie_frame_title(
            { category: "{category}" },
            { locale: "lv" }
          ),
        },
        legalLinks: {
          ...baseTranslations.lv.legalLinks,
          termsOfService: m.footer_terms_of_service({}, { locale: "lv" }),
        },
      },
    },
  };
}
